"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPositionProperty = exports.PopOutMenuArrowSide = void 0;
var PopOutMenuArrowSide;
(function (PopOutMenuArrowSide) {
    PopOutMenuArrowSide["NONE"] = "none";
    PopOutMenuArrowSide["TOP"] = "top";
    PopOutMenuArrowSide["RIGHT"] = "right";
    PopOutMenuArrowSide["BOTTOM"] = "bottom";
    PopOutMenuArrowSide["LEFT"] = "left";
})(PopOutMenuArrowSide = exports.PopOutMenuArrowSide || (exports.PopOutMenuArrowSide = {}));
/**
 * Generate the css required to position the arrow on the menu
 * @param arrowSide the side of the box on which the arrow should sit
 * @param arrowPosition the position from the start of that side
 */
var getPositionProperty = function (arrowSide, arrowPosition) {
    switch (arrowSide) {
        case PopOutMenuArrowSide.TOP:
            return {
                left: arrowPosition,
                top: 0,
                transform: "translate(-50%, -50%)"
            };
        case PopOutMenuArrowSide.RIGHT:
            return {
                right: 0,
                top: arrowPosition,
                transform: "translate(50%, -50%)",
            };
        case PopOutMenuArrowSide.BOTTOM:
            return {
                bottom: 0,
                left: arrowPosition,
                transform: "translate(-50%, 50%)"
            };
        case PopOutMenuArrowSide.LEFT:
            return {
                left: 0,
                top: arrowPosition,
                transform: "translate(-50%, -50%)"
            };
        default:
            return {
                display: "none",
                transform: "none"
            };
    }
};
exports.getPositionProperty = getPositionProperty;
